/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import SearchField from "components/fields/SearchField";
import { IoIosCopy } from "react-icons/io";
import { PiQuestionLight } from "react-icons/pi";
import { PiEyeLight } from "react-icons/pi";
import { MdNavigateNext, MdNavigateBefore, MdSkipPrevious, MdSkipNext } from "react-icons/md";
import { Link } from "react-router-dom";
import ReactTooltip from 'react-tooltip';
import Opensea from "assets/img/icons/opensea.png";
import NftIcon from "assets/img/icons/nft.png";

const Trades = () => {
  return (
    <div className="relative">
      {/* Card widget */}
      <div className="header-back-gradient">
        <div className="container">
          <div className="w-full flex items-center px-5 py-6">
            <div className="md:flex justify-between w-full md:py-6">
              <p className="relative text-header text-white md:mb-0 mb-4">Dex Tracker</p>
              <SearchField
                extra="sm:min-w-[480px] xl:min-w-[650px]"
                placeholder="Search by Address/ Txn Hash/ Block/ Token/Domain Name"
                id="email"
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mt-12 mb-12 px-2.5 md:px-3 lg:px-5">
          <div className="box bg-white dark:bg-darkPrimary overflow-hidden">
            <div className="flex flex-col mt-5">
              <div className="flex gap-1 flex-row items-center justify-between flex-wrap w-full px-5 py-4">
                <div className="not-italic text-large">
                More than 643,280,993 transactions found
                </div>
              </div>
            </div>
            <div className="table-wrapper">
              <table className="table w-full">
                <thead>
                  <tr className="">
                    <th className="w-[10px] !min-w-0 !pr-0"><a href="#" className="text-large" data-for="txs-tip" data-tip="See preview of Transactions Details"><PiQuestionLight /></a></th>
                    <th className="">Txn Hash</th>
                    <th className="">Block</th>
                    <th className="">Age</th>
                    <th className="">Action</th>
                    <th className="">Price</th>
                    <th className="">Market</th>
                    <th className="">Buyer</th>
                    <th className="">Item</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    Array(4).fill(0).map((data) => <tr>
                      <td className="!pr-0">
                        <a href="#" className="text-large"><PiEyeLight /></a>
                      </td>
                      <td>
                        <div className="flex gap-[1px] max-w-[160px]">
                          <div className="truncateWrapper">
                            <Link to="/txs/3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b" className="text-green-900 text-small truncate">
                              3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b
                            </Link>
                          </div>
                          <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                        </div>
                      </td>
                      <td>
                        <p className="text-small text-green-900">109,901,461</p>
                      </td>
                      <td>
                        <p className="text-small ">12 secs ago</p>
                      </td>
                      <td>
                        <p className="text-small text-green-900">Bought</p>
                      </td>
                      <td>
                        <p className="text-small">0.01 BBA</p>
                      </td>
                      <td>
                        <p className="text-small flex items-center gap-1">
                          <img
                            src={Opensea}
                            width={16}
                            height={16}
                          />
                          Opensea
                        </p>
                      </td>
                      <td>
                        <div className="flex gap-[1px] max-w-[160px]">
                          <div className="truncateWrapper">
                            <p className="text-green-900 text-small truncate">0x6d4C3166903a5471</p>
                          </div>
                          <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                        </div>
                      </td>
                      <td>
                        <p className="text-green-900 text-small truncate flex items-center gap-1">
                          <img
                            src={NftIcon}
                            className="rounded-1 w-6 h-6 ml-auto"
                            alt=""
                          />
                          Owl Bridge #475
                        </p>
                      </td>
                    </tr>)
                  }
                  
                </tbody>
              </table>
            </div>
            <div className="p-5 justify-center md:justify-between flex mb-2">
              <div className="md:flex gap-2 hidden">
                <span className="text-small flex items-center">Show</span>
                <select className="text-small">
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                  <option>100</option>
                </select>
                <span className="text-small flex items-center">Per Page</span>
              </div>
              <div className="flex gap-2">
                <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdSkipPrevious /></button>
                <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdNavigateBefore /></button>
                <span className="text-small flex items-center px-2">Page 1 of 25</span>
                <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdNavigateNext /></button>
                <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdSkipNext /></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReactTooltip
        id="txs-tip"
        place="right"
        effect="solid"
        class="custom-tooltip right"
      />
    </div>
  );
};

export default Trades;
